var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatbot-answer-choices-vertical-wrapper"},[_c('div',{staticClass:"chatbot-answer-choices-vertical",style:({ borderColor: _vm.config.choicesColor })},_vm._l((_vm.choices),function(choice){return _c('button',{key:choice.id,style:({
        borderColor: _vm.config.choicesColor,
        color: _vm.config.choicesColor
      }),on:{"click":function($event){return _vm.sendChoiceAnswer(choice)}}},[_vm._v(" "+_vm._s(choice.displayText)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }